import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiTrainingModuleConstants } from "../../constants/api-constants/api-training-module.constants";
let TrainingModuleService = class TrainingModuleService {
    http;
    constructor(http) {
        this.http = http;
    }
    getApplicationSetPropertiesObservable(applicationId, params) {
        return this.http.post(`${ApiTrainingModuleConstants.URL}/${applicationId}/${ApiTrainingModuleConstants.FUNCTION_SET_PROPERTIES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
TrainingModuleService = __decorate([
    Injectable({
        providedIn: "root"
    })
], TrainingModuleService);
export { TrainingModuleService };
